import { render, staticRenderFns } from "./AssetDocuments.vue?vue&type=template&id=775cbebe&scoped=true&"
import script from "./AssetDocuments.vue?vue&type=script&lang=js&"
export * from "./AssetDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AssetDocuments.vue?vue&type=style&index=0&id=775cbebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775cbebe",
  null
  
)

/* custom blocks */
import block0 from "./AssetDocuments.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports